export default __webpack_public_path__ + "static/media/LightBlue0002.57900a49.png";